import React, { useEffect } from "react";
import PropTypes from "prop-types";
import TailwindWrapper from "../components/TailwindWrapper/TailwindWrapper";
import { trackPageLoadEvent } from "../shared/services/analytics/AnalyticsService";
import { Trans, useTranslation } from "react-i18next";

/**
 * GetStarted component for the onboarding flow
 * Provides an introduction and overview of the onboarding process
 */
const GetStarted = ({ user }) => {
  const { t } = useTranslation();

  const descriptionList = t("NVCOnboarding.getStarted.description_list", {
    returnObjects: true,
  });

  useEffect(() => {
    if (user) {
      trackPageLoadEvent("fv:emp:nvc:onboarding", user, "emp:nvc");
    }
  }, [user]);

  return (
    <TailwindWrapper>
      <div className="tw-mb-6">
        <h1 className="tw-text-3xl tw-font-normal tw-text-gray-900 tw-mb-3 tw-mt-0">
          {t("NVCOnboarding.getStarted.title")}
        </h1>

        <p className="tw-text-md tw-mb-4">
          {t("NVCOnboarding.getStarted.introDescription")}
        </p>
        <p
          className="tw-text-md tw-mb-4 tw-font-bold"
          data-testid="parts-onboarding-effective-date"
        >
          {t("NVCOnboarding.getStarted.effectiveDate")}
        </p>
        <ul
          className="tw-list-disc tw-mb-4 tw-ml-6 tw-pl-0 tw-mt-0"
          data-testid="parts-onboarding-important-updates-list"
        >
          <li
            className="tw-text-md tw-mb-2 tw-pl-2"
            data-testid="parts-onboarding-important-updates-b2b-decommission"
          >
            <span className="tw-font-bold">
              {t("NVCOnboarding.getStarted.b2bPartsSiteDecommission")}
            </span>{" "}
            <span>
              {t(
                "NVCOnboarding.getStarted.b2bPartsSiteDecommissionDescription"
              )}
            </span>
          </li>
          <li className="tw-text-md tw-mb-2 tw-pl-2">
            <span className="tw-font-bold">
              {t("NVCOnboarding.getStarted.updatedTermsAndConditions")}
            </span>{" "}
            <Trans
              i18nKey="NVCOnboarding.getStarted.updatedTermsAndConditionsDescription"
              components={[
                <a
                  key="0"
                  href="https://www.dpesng.dealerconnection.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-text-blue-600 tw-underline"
                >
                  Dealer Connection
                </a>,
              ]}
            />
          </li>
        </ul>

        <p className="tw-text-md tw-mb-2 tw-pl-4">
          {t("NVCOnboarding.getStarted.description_line2")}
        </p>

        <ul
          className="tw-list-disc tw-list-inside tw-mb-4 tw-ml-0 tw-pl-6 tw-mt-0"
          data-testid="parts-onboarding-action-list"
        >
          {Array.isArray(descriptionList) &&
            descriptionList.map((item, index) => (
              <li
                key={item}
                className="tw-text-md tw-mb-2"
                data-testid={`parts-onboarding-action-list-item-${index}`}
              >
                {item}
              </li>
            ))}
        </ul>
      </div>
    </TailwindWrapper>
  );
};

GetStarted.propTypes = {
  user: PropTypes.object,
};

export default GetStarted;
